import Ajv from 'ajv';
import * as UserScheme from './scheme.json';

const ajv = new Ajv();
export const UserValidator = ajv.compile(UserScheme);
